<template>
  <GeneralUser />
</template>

<script>
import GeneralUser from "../../components/GeneralUser/GeneralUser.vue";
export default {
  components: {
    GeneralUser,
  },
};
</script>